// Skill refresh (#2020, 1 Nov 2026): an open chat reloads a saved skill at
// its next message when the skill was saved again, and says so under that
// message. It only talks, on the agent start screen and Admin → Skills: it
// never saves a skill or sends a message, since a save changes what every
// chat of the customer receives and a message spends credits.

import type { Walkthrough } from './types'

export const skillRefresh: Walkthrough = {
  slug: 'skill-refresh',
  title: 'Chats use the newest saved skills',
  summary:
    'Explains how an open chat picks up a skill that was saved again: at your next message, with a line under it saying which version it now uses. Nothing is saved or sent.',
  issue: '#2020',
  added: '2026-11-01',
  steps: [
    {
      page: 'admin-agent-skills',
      feature: 'skills/skills-library',
      say: 'Skills are saved here, or in the Skills tab of a chat. Company-level skills, Bayes Price skills and your own are in every chat you open, without installing them.',
    },
    {
      page: 'admin-agent-skills',
      feature: 'skills/skill-tiers',
      say: 'When one of those skills is saved again, chats that are already open pick up the new version too. You do not need to start a new chat or install the skill again.',
    },
    {
      page: 'agent',
      feature: 'agent/skill-refresh',
      say: 'The change reaches an open chat at your next message. Before the agent answers, the chat reloads its skills, and a line under your message says Now using, the skill’s name, and when that version was saved, in your own time.',
    },
    {
      page: 'agent',
      feature: 'agent/skill-refresh',
      say: 'A reply that is already running is never interrupted: the reload waits for your next message. The conversation carries on as before, but anything the chat was still doing in the background stops when it reloads.',
    },
    {
      page: 'agent',
      feature: 'agent/skill-refresh',
      say: 'Built-in skills never cause a reload, and nothing happens when no skill changed. I have not saved a skill or sent a message here.',
    },
  ],
}
